module.exports = __webpack_public_path__ + "img/A18b_REF PAM NA 9330-08 C2 R4 1992.e5d68e21.jpg";